import Component from '@glimmer/component';
import { action } from '@ember/object';
import { addObserver, removeObserver } from '@ember/object/observers';
import { inject as service } from '@ember/service';
import { checkEventPendingFeed } from 'mewe/fetchers/fetch-feed';

export default class AppEventFeed extends Component {
  element;

  @service router;

  constructor() {
    super(...arguments);

    if (!this.args.model.preventScroll) {
      window.scrollTo(0, 0);
    }

    this.checkPendingFeed();
    addObserver(this, 'args.model.eventState.rootEvent.id', this.checkPendingFeed);
  }

  @action
  didInsert(element) {
    this.element = element;
  }

  @action
  willDestroy() {
    removeObserver(this, 'args.model.eventState.rootEvent.id', this.checkPendingFeed);
  }

  checkPendingFeed() {
    // check pendig feed after event is fetched to avoid possible race condition (SG-29925)
    const eventId = this.args.model.eventState.rootEvent?.id;
    if (eventId) checkEventPendingFeed(eventId);
  }

  @action
  openEventHashTagFeed(hash) {
    // passing route and eventId is needed here in case of click on hashtag in
    // "/feed-pending" route because we need to rediredt to "/feed" in that case
    this.router.transitionTo('app.event.feed', this.args.model.eventState.rootEvent.id, { queryParams: { tag: hash } });
  }
}
